module.exports = __webpack_public_path__ + "img/blue_003.c6413c8d.png";